/* tslint:disable */
/* eslint-disable */
/**
 * CyberWell Aegis API
 * Multi-tenant case management API with JWT auth, RBAC (Casbin), audit logging, and tenant isolation.
 *
 * The version of the OpenAPI document: v1
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { Property } from './Property';
import {
    PropertyFromJSON,
    PropertyFromJSONTyped,
    PropertyToJSON,
    PropertyToJSONTyped,
} from './Property';
import type { Link } from './Link';
import {
    LinkFromJSON,
    LinkFromJSONTyped,
    LinkToJSON,
    LinkToJSONTyped,
} from './Link';

/**
 * 
 * @export
 * @interface Revision
 */
export interface Revision {
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    tenantId?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    id?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    title?: string;
    /**
     * 
     * @type {Date}
     * @memberof Revision
     */
    published?: Date;
    /**
     * 
     * @type {Date}
     * @memberof Revision
     */
    lastModified?: Date;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    version?: string;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    oscalVersion?: string;
    /**
     * 
     * @type {Array<Property>}
     * @memberof Revision
     */
    props?: Array<Property>;
    /**
     * 
     * @type {Array<Link>}
     * @memberof Revision
     */
    links?: Array<Link>;
    /**
     * 
     * @type {string}
     * @memberof Revision
     */
    remarks?: string;
}

/**
 * Check if a given object implements the Revision interface.
 */
export function instanceOfRevision(value: object): value is Revision {
    return true;
}

export function RevisionFromJSON(json: any): Revision {
    return RevisionFromJSONTyped(json, false);
}

export function RevisionFromJSONTyped(json: any, ignoreDiscriminator: boolean): Revision {
    if (json == null) {
        return json;
    }
    return {
        
        'tenantId': json['tenantId'] == null ? undefined : json['tenantId'],
        'id': json['id'] == null ? undefined : json['id'],
        'title': json['title'] == null ? undefined : json['title'],
        'published': json['published'] == null ? undefined : (new Date(json['published'])),
        'lastModified': json['lastModified'] == null ? undefined : (new Date(json['lastModified'])),
        'version': json['version'] == null ? undefined : json['version'],
        'oscalVersion': json['oscalVersion'] == null ? undefined : json['oscalVersion'],
        'props': json['props'] == null ? undefined : ((json['props'] as Array<any>).map(PropertyFromJSON)),
        'links': json['links'] == null ? undefined : ((json['links'] as Array<any>).map(LinkFromJSON)),
        'remarks': json['remarks'] == null ? undefined : json['remarks'],
    };
}

export function RevisionToJSON(json: any): Revision {
    return RevisionToJSONTyped(json, false);
}

export function RevisionToJSONTyped(value?: Revision | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'tenantId': value['tenantId'],
        'id': value['id'],
        'title': value['title'],
        'published': value['published'] == null ? undefined : ((value['published']).toISOString()),
        'lastModified': value['lastModified'] == null ? undefined : ((value['lastModified']).toISOString()),
        'version': value['version'],
        'oscalVersion': value['oscalVersion'],
        'props': value['props'] == null ? undefined : ((value['props'] as Array<any>).map(PropertyToJSON)),
        'links': value['links'] == null ? undefined : ((value['links'] as Array<any>).map(LinkToJSON)),
        'remarks': value['remarks'],
    };
}

